export const CROP_CATEGORIES = [
  { id: 'grains', icon: '🌾' },
  { id: 'vegetables', icon: '🥦' },
  { id: 'berries', icon: '🍓' },
  { id: 'fruits', icon: '🍎' },
  { id: 'stone_fruit', icon: '🍒' },
  { id: 'legumes', icon: '🫘' },
  { id: 'wine', icon: '🍷' }
];

export const CATEGORY_ICONS = Object.fromEntries(
  CROP_CATEGORIES.map((cat) => [cat.id, cat.icon])
);

export const CROP_ICONS = {
  potato: '🥔',
  coffee: '☕',

  'malus_domestica:honeycrisp': '🍎',
  'prunus_persica:elberta': '🍑',
  'prunus_avium:bing': '🍒',
  'solanum_lycopersicum:roma': '🍅',
  'glycine_max:pioneer': '🫛',
  'fragaria_ananassa:albion': '🍓',
  'fragaria_ananassa:jewel': '🍓',
  'fragaria_ananassa:ac_wendy': '🍓',
  'fragaria_ananassa:valley_sunset': '🍓',
  'fragaria_ananassa:seascape': '🍓',
  'vaccinium_corymbosum:bluecrop': '🫐',
  'vaccinium_corymbosum:duke': '🫐',
  'vaccinium_corymbosum:patriot': '🫐',
  'vaccinium_angustifolium:wild': '🫐',
  'vaccinium_corymbosum:northblue': '🫐',
  'rubus_idaeus:boyne': '',
  'rubus_idaeus:nova': '',
  'rubus_idaeus:heritage': '',
  'rubus_idaeus:killarney': '',
  'vitis_riparia:marquette': '🍇',
  'vitis_hybrid:frontenac': '🍇',
  'vitis_hybrid:vidal_blanc': '🍇',
  'vitis_vinifera:chardonnay': '🍇',
  'vitis_vinifera:riesling': '🍇',
  'vitis_vinifera:cabernet_franc': '🍇',
  'vitis_vinifera:pinot_noir': '🍇',
  'vitis_vinifera:gewurztraminer': '🍇',
  'vitis_hybrid:cayuga_white': '🍇',
  'vitis_vinifera:merlot': '🍇',
  'vitis_vinifera:sauvignon_blanc': '🍇',
  'vitis_vinifera:cabernet_sauvignon': '🍇',
  'vitis_vinifera:zinfandel': '🍇',
  'zea_mays:katumani': '🌽',
  'manihot_esculenta:cassava': '🍠',
  'arachis_hypogaea:groundnut': '🥜',
  'dioscorea_rotundata:yam': '🍠',
  'triticum_aestivum:wheat': '🌾',
  'cucurbita_moschata:pumpkin': '🎃',


};

// Returns a specific crop icon, falls back to its category icon, or a default sprout icon
export const getCropIcon = (crop) => {
  if (!crop) return '🌱';
  return CROP_ICONS[crop.id] || CATEGORY_ICONS[crop.category] || '🌱';
};

export const SITE_SIZES = [
  { id: 'small', minSize: 0 },
  { id: 'medium', minSize: 1 },
  { id: 'large', minSize: 5 },
  { id: 'enterprise', minSize: 21 }
];

export const getHazardsByCropId = (cropsList, cropId) => {
  const crop = cropsList.find((c) => c.id === cropId);
  return crop ? crop.hazards : [];
};
